import { render, staticRenderFns } from "./menuOperDesign.vue?vue&type=template&id=645382fa&scoped=true"
import script from "./menuOperDesign.vue?vue&type=script&lang=js"
export * from "./menuOperDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645382fa",
  null
  
)

export default component.exports